/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ApproverRoleEnum } from "./approver-role.enum";

export interface CycleShare { 
   /**
    * The list of approvers of the external user to create the link/mail(/etc...) for
    */
    approvers?: ApproverShare[];
   /**
    * The way of sharing. Copy link, send it by mail, etc...
    */
   share_method?: ShareMethodEnum;
   /**
    * Custom message to include with sharing via messaging platforms (mail, slack, etc..)
    */
   message?: string;
}

export interface ApproverShare {
    email?: string;
    approver_type?: ApproverRoleEnum;
}

export type ShareMethodEnum = 'email' | 'link';
export const ShareMethodEnum = {
  Email: 'email' as ShareMethodEnum,
  Link: 'link' as ShareMethodEnum
};
